import { render, staticRenderFns } from "./Prod.vue?vue&type=template&id=0ff2c8b1&"
import script from "./Prod.vue?vue&type=script&lang=js&"
export * from "./Prod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports